export const Kbd = {
  baseStyle: {
    fontSize: '12px',
    color: 'gray.700'
  }
};
